const T = require('prop-types');
const { default: Badge } = require('@mui/material/Badge');
const { default: Styled } = require('styled-components');

const internals = {};

module.exports = (props) => {

    const {
        numUnreads,
        className,
        // TODO figure out what to do with 'mini'
        mini, // eslint-disable-line no-unused-vars
        dispatch, // eslint-disable-line no-unused-vars
        ...rest
    } = props;

    const { StyledBadge } = internals;

    return (
        <StyledBadge
            // TODO make sure screen readers are able to read this info somewhere
            // aria-label={`${numUnreads} Unread Messages`}
            badgeContent={numUnreads}
            // badgeContent={9}
            color='secondary'
            max={9}
            className={className}
            overlap='circular'
            {...rest}
        />
    );
};

module.exports.displayName = 'UnreadMessagesBadge';

module.exports.propTypes = {
    numUnreads: T.oneOfType([T.number, T.string]),
    className: T.string,
    mini: T.bool,
    dispatch: T.func
};

internals.StyledBadge = Styled(Badge)`
    .MuiBadge-badge {
        top: 0px;
        right: 0px;
    }
`;